<template>
  <button @click="$emit('any-task')" :style="{ background: color }" class="btn">
    {{ text }}
  </button>
</template>

<script>
  export default {
    data() {
      return {
        hover: false,
      };
    },
  name: 'Button',
  props: {
    text: String,
    color: String,
  },
  methods: {
    onClick() {
      console.log('Clicked')
    },
  },
}
</script>

<style>
  .btn {
    display: inline-block;
    background: #000;
    color: #fff;
    border: none;
    padding: 6px 16px;
    margin: 5px;
    border-radius: 5px;
    cursor: pointer;
    text-decoration: none;
    font-size: 15px;
    font-family: inherit;
    min-width: 100px;
  }

  .btn:focus {
    outline: none;
  }

  .btn:active {
    transform: scale(0.98);
  }

.btn-block {
  display: block;
  width: 100%;
}
</style>

